import z from 'zod';
import arrayEntry from './arrayEntry.js';
import internationalizedArraySanityFileValue from '../objects/internationalizedArraySanityFileValue.js';
var id = 'internationalizedArraySanityFile';
var fragment = {
    type: 'array',
    of: [
        {
            type: 'internationalizedArraySanityFileValue'
        }
    ]
};
var validator = z.array(internationalizedArraySanityFileValue.validator.merge(arrayEntry.validator));
export default {
    id: id,
    fragment: fragment,
    validator: validator
};

//# sourceMappingURL=internationalizedArraySanityFile.js.map